import { render, staticRenderFns } from "./InsetTool.vue?vue&type=template&id=52d1d2bd&scoped=true&"
import script from "./InsetTool.vue?vue&type=script&lang=js&"
export * from "./InsetTool.vue?vue&type=script&lang=js&"
import style0 from "./InsetTool.vue?vue&type=style&index=0&id=52d1d2bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d1d2bd",
  null
  
)

export default component.exports